module.exports = __webpack_public_path__ + "img/logo.efeaed8c.png";